import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/tasks` has no screen of its own - it redirects to the plans tab.
 *
 * A `beforeLoad` redirect rather than a default child, so the URL always names
 * which tab is showing. The sidebar and the warehouse front door both link at
 * `/tasks`, and a bookmark taken from either has to survive whichever tab we
 * later decide leads.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/$lang/orgs/$org/outbound/whs/$location/tasks/plans",
      params,
      // The filters carry through the redirect. `/tasks?routeQuery=20481` is a
      // link a manager can be sent, and a redirect that keeps the params but
      // drops the search hands them the unfiltered screen instead.
      search,
      replace: true,
    });
  },
});
